module.exports = __webpack_public_path__ + "static/training-room-21b4949be0c3e91e5311a1f53b683645.jpg";